class DictUtil {
  /**
   * @param {Object} params 字典对象，参考结构：
   * {
   *   XXX_VALUE: { value: 1, label: 'xxx', ...},
   *   ...
   * }
   */
  constructor(params) {
    this.keyMap = {}
    this.valueMap = {}

    Object.keys(params).forEach(key => {
      // this.keyMap.set(key, params[key])
      // this.valueMap.set(params[key].value, params[key])
      this.keyMap[key] = params[key]
      this.valueMap[params[key].value] = params[key]
      this[key] = params[key]
    })
  }

  /**
   * 关键词数组
   */
  get keys() {
    // return Array.from(this.keyMap.keys());
    return Object.keys(this.keyMap)
  }

  /**
   * 字典值数组
   */
  get values() {
    // return this.array.map((item) => item.value);
    return Object.keys(this.valueMap)
  }

  /**
   * 词条数组
   */
  get array() {
    // return Array.from(this.keyMap.values());
    return this.keys.map(key => this.keyMap[key])
  }

  /**
   * 字典对象
   */
  get object() {
    // return Object.fromEntries(this.keyMap);
    return this.keyMap
  }

  /**
   * 根据字典值获取词条信息
   * @param {*} value 字典值
   * @returns 词条信息
   */
  translate(value) {
    // return this.valueMap.get(value) || {};
    return this.valueMap[value] || {}
  }

  /**
   * 根据关键词获取词条信息
   * @param {*} key 关键词
   * @returns {Object} 词条信息
   */
  get(key) {
    // return this.keyMap.get(key) || {};
    return this.keyMap[key] || {}
  }

  /**
   * 字典生成数组（即将废弃）
   * @returns {Array} 生成的数组
   */
  get dictArray() {
    // TODO: 等外部使用的地方全部替换为array后废弃
    return this.array
  }

  /**
   * 字典值生成数组（即将废弃）
   * @returns {Array} 生成的数组，元素为字典值value
   */
  get dictValueArray() {
    // TODO: 等外部使用的地方全部替换为array后废弃
    return this.values
  }

  /**
   * 字典对象（即将废弃）
   * @returns {Object}
   */
  get dictObj() {
    // TODO: 等外部使用的地方全部替换为array后废弃
    return this.object
  }
}

export default DictUtil
